import Mux, { Asset, Video, Upload } from '@mux/mux-node';
import MuxAPIService from '../services/mux.service';

const accessToken = process.env.REACT_APP_MUX_TOKEN_ID;
const secret = process.env.REACT_APP_MUX_TOKEN_SECRET;

export interface IMuxHelper {
  mux: Mux;
  video: Video;
  createUpload(): Promise<{ url: string; id: string }>;
  getUploadById(id: string): Promise<Upload | undefined>;
  getAssetsByUploadId(id: string): Promise<Asset | undefined>;
  getAssetsById(id: string): Promise<Asset | undefined>;
  getPlaybackIdByAssetId(id: string): Promise<string | undefined>;
  getSourceByAssetId(id: string): Promise<{ src: string | undefined; poster: string | undefined }>;

  // ----- API ----- //
  // fetchUpload(): Promise<{ url: string; id: string }>;
  // fetchSource(): Promise<{ url: string; id: string }>;
  // fetchAssetsByUploadId(): Promise<{ url: string; id: string }>;
  // fetchAssetsById(): Promise<{ url: string; id: string }>;
}

export default class MuxHelper implements IMuxHelper {
  mux;
  video;

  constructor() {
    const mux = new Mux(accessToken, secret);
    this.mux = mux;
    this.video = mux.Video;
  }

  async getSourceByAssetId(id: string): Promise<{ src: string | undefined; poster: string | undefined }> {
    const playbackId = await this.getPlaybackIdByAssetId(id);
    let src;
    let poster;
    if (!playbackId) return { src, poster };

    src = `https://stream.mux.com/${playbackId}.m3u8`;
    poster = `https://image.mux.com/${playbackId}/thumbnail.png`;

    return { src, poster };
  }

  async getUploadById(id: string): Promise<Upload | undefined> {
    try {
      const upload = await this.video.Uploads.get(id);
      if (!upload) return;

      return upload;
    } catch (error) {
      console.log('getUploadById: ' + error);
      return;
    }
  }

  async getAssetsById(id: string): Promise<Asset | undefined> {
    try {
      const assets = await this.video.Assets.get(id);
      if (!assets) return;

      return assets;
    } catch (error: any) {
      console.log('MuxHelper::getAssetsById: ', error);
      return;
    }
  }

  async getPlaybackIdByAssetId(id: string): Promise<string | undefined> {
    try {
      const assets = await this.getAssetsById(id);

      if (!assets) return;
      if (!assets?.playback_ids?.length) return;

      const playbackId = assets.playback_ids[0].id;

      return playbackId;
    } catch (error) {
      console.log('getAssetsById: ' + error);
      return;
    }
  }

  async getAssetsByUploadId(id: string): Promise<Asset | undefined> {
    try {
      const upload = await this.getUploadById(id);
      if (!upload?.asset_id) return;

      const assets = await this.getAssetsById(upload.asset_id);
      return assets;
    } catch (error) {
      console.log('getAssetsByUId: ' + error);
      return;
    }
  }

  async createUpload() {
    const upload = await this.video.Uploads.create({
      cors_origin: '*',
      new_asset_settings: { playback_policy: 'public' },
    });

    return { url: upload.url, id: upload.id };
  }

  // ----- API ----- //

  async fetchUpload() {
    const service = new MuxAPIService();
    const { url, id } = await service.createUpload();

    return { url, id };
  }

  async fetchSourceByAssetId(id: string) {
    const service = new MuxAPIService();
    const source = await service.getSourceByAssetId(id);

    return source;
  }

  async fetchAssetsByUploadId(id: string) {
    const service = new MuxAPIService();
    const assets = await service.getAssetsByUploadId(id);

    return assets;
  }

  async fetchAssetsById(id: string) {
    const service = new MuxAPIService();
    const assets = await service.getAssetsById(id);

    return assets;
  }
}
